import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbbrPipe } from './abbr.pipe';

@NgModule({
  declarations: [AbbrPipe],
  imports: [CommonModule],
  exports: [AbbrPipe]
})
export class AbbrModule {}
